/**
 * Converts an HTML message to Markdown
 * @param message The original message in HTML format.
 * @returns A string formatted in Markdown
 */
export const formatDisqualifiedMessage = (message: string): string => {
  return message
    .replaceAll("<p>", "\n")
    .replaceAll("</p>", "\n")
    .replaceAll("<ul>", "\n")
    .replaceAll("</ul>", "")
    .replaceAll("<li>", "- ")
    .replaceAll("</li>", "");
};
